import { logOutReducerTypes } from 'types/store/auth/logOut';

const logOutState: logOutReducerTypes.ILogOut = {
    // Reducer
    isLoading: false,

    // Response
    message: '',
    status: false,
};

export { logOutState };
